<template>
  <div class="wrap">
    <div class="main">
      <div class="content">
        <span>取消订单</span>
        <Icon @click="cancel" size="20" type="ios-close-circle-outline" />
      </div>

      <Form class="form" label-position="top" style="margin-top: 25px;">
        <FormItem label="请选择：">
          <tabNav :list="typeList" v-model="single_id"></tabNav>
        </FormItem>

      </Form>

      <div class="btn-grounp">
        <Button type="text" @click="cancel">取消</Button>
        <Button type="primary" @click="confirm">确认</Button>
      </div>
    </div>
  </div>
</template>

<script>
import tabNav from '../../components/tabNav'
export default {
  name: 'cancelOrder',
  components: {
    tabNav
  },
  data () {
    return {
      single_id: 0,
      typeList: [],
      desc: '',
      id: '',
      text: '',
      loading: false
    }
  },
  created () {
    let vm = this
    this.$request('61177c8371904', {
      scene: '10'
    }).then(res => {
      vm.typeList = []
      res.data.data.forEach(function (item) {
        vm.typeList.push({
          value: item.id,
          label: item.name
        })
      })
      if (vm.typeList.length > 0) {
        vm.single_id = vm.typeList[0].value
      }
      console.log(vm.typeList)
    })
  },
  methods: {
    show (cb) {
      typeof cb === 'function' && cb.call(this, this)
      return new Promise(resolve => {
        this.resolve = resolve
      })
    },
    confirm () {
      if (this.single_id == 0) {
        return this.$message.error('请选择原因')
      }
      if (this.loading) return
      this.loading = true

      this.$request('6190782249cfd', {
        order_id: this.id,
        scene: this.single_id,
        single_id: this.single_id
      }).then(res => {
        this.resolve('confirm')
        this.hide()
      }).finally(() => {
        this.loading = false
      })
    },
    cancel () {
      this.resolve('cancel')
      this.hide()
    },
    hide () {
      document.body.removeChild(this.$el)
      this.$destroy()
    }
  }
}

</script>

<style scoped lang="less">
.wrap{
  position: fixed;
  top: 0;
  bottom:0;
  z-index: 9999999999;
  left:0;
  right:0;
  display:flex;
  justify-content: center;
  align-items: center;
  background: rgba(0,0,0,.6);
  .main{
    width: 40%;
    padding: 10px;
    background: #fff;
    border-radius: 5px;
  }
  .body{
    padding: 20px 0;

    .desc{
      font-size: 14px;
      margin-bottom: 10px;
    }

    .text{
      font-weight: bold;
      font-size: 30px;
      color: #000;
      letter-spacing: 2px;
    }
  }
  .content{
    color:#424242;
    font-size: 20px;
    display: flex;
    justify-content: space-between;

  }
  .btn-grounp{
    margin-top: 15px;
    display:flex;
    justify-content: flex-end;
  }
  .btn{
    margin-left: 15px;
    padding: 5px 20px;
    border-radius: 5px;
    font-size: 16px;
    color:#fff;
  }
  .confirm{
    background: lightblue;
  }
  .cancel{
    background: lightcoral;
  }
}

</style>
